import {
  FETCH_GROUP_MEMBERS_SUCCESS,
} from './actions';
import { Map } from 'immutable';
import Member from './model';

export default function groupMembers(state = new Map({}), action) {
  switch (action.type) {
    case FETCH_GROUP_MEMBERS_SUCCESS:
      return onSuccess(state, action);
    default:
      return state;
  }
}

function onSuccess(state, action) {
  let newState = state;
  action.payload.forEach((member) => {
    const memberModel = Member.create(Object.assign({}, member, { groupId: action.groupId }));
    newState = newState.set(memberModel.studentGeneralInfo.id, memberModel);
  });
  return newState;
}



// WEBPACK FOOTER //
// ./data/GroupMembers/reducer.js